import axios from '@/utils/axios';
import queryString from '@/utils/queryString';

export default {
    namespaced: true,
    state: {
        receiveNote: null,
        receiveNotes: [],
        userRules: null
    },
    mutations: {
        setReceiveNote(state, payload) {
            state.receiveNote = payload;
        },
        setReceiveNotes(state, payload) {
            state.receiveNotes = payload;
        },
        setUserRules(state, payload) {
            state.userRules = payload;
        }
        
    },
    actions: {
        storeReceiveNote({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: `${rootState.warehouse.routePrefix}/receive-notes`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        updateReceiveNote({rootState, dispatch}, payload) {
            return new Promise((resolve, reject)=> {
                axios.request({
                    method: "put",
                    url: `${rootState.warehouse.routePrefix}/receive-notes/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        removeReceiveNote({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.warehouse.routePrefix}/receive-notes/${payload.id}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        removeReceiveNotes({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.warehouse.routePrefix}/receive-notes`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        fetchReceiveNote({commit, rootState, dispatch}, payload) {
            return new Promise((resolve, reject) =>{
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/receive-notes/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setReceiveNote', response.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        fetchReceiveNotes({commit, rootState, dispatch}, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) =>{
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/receive-notes?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setReceiveNotes', response.data.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        fetchUserRules({commit, rootState,state}) {
            if(!state.userRules) {
                return new Promise((resolve, reject) => { 
                    axios.request({
                        method: 'get',
                        url: `${rootState.warehouse.routePrefix}/receive-notes-rules`,
                        headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                    })
                    .then((response) => {
                        commit('setUserRules', response.data);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        // if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                        reject(error);
                    })
                })
            }
        },

    }
}